import {validateToken} from "../helpers/validateToken";

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

const initialState = validateToken() ? {loggedIn: true} : {loggedIn: false};

export const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                loggedIn: true
            };

        case LOGOUT:
            return {
                ...state,
                loggedIn: false
            };

        default:
            return state;
    }
};
